//src/admin/features/accountants/accountantsModals/formFields.ts
import { ITimezone } from 'app/services/constants';
import { Validators } from 'utils/Validators';
import * as Yup from 'yup';

export const validationSchemaBasicInfo = Yup.object().shape({
  given_name: Yup.string().trim().required('required'),
  family_name: Yup.string().trim().required('required'),
  email: Yup.string().trim(),
  zipcode: Validators.zipCode.required('required'),
  time_zone_id: Yup.number().required('required'),
  address: Yup.string().required('required'),
});
export type FormInputsBasicInfo = {
  given_name: string;
  family_name: string;
  email: string;
  zipcode: string;
  time_zone_id?: number;
  address: string;
};

export const validationSchemaAbout = Yup.object().shape({
  about: Yup.string().required('required'),
  title: Yup.string().required('required'),
});
export type FormInputsAbout = {
  about: string;
  title: string;
};

export const validationSchemaWorkExperiences = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required('required')
    .max(50, 'Title must be below 50 Character ')
    .min(2, 'Title must be more than 2 Character'),
  company: Yup.string()
    .trim()
    .required('required')
    .max(120, 'Company must be below 120 Character ')
    .min(2, 'Company must be more than 2 Character'),

  started_at: Yup.string()
    .trim()
    .required('required')
    .typeError('Start Date is Required'),
  ended_at: Yup.string().trim().nullable(),
});
export type FormInputsWorkExperiences = {
  title: string;
  company: string;
  started_at: string;
  ended_at: string;
};
export const validationSchemaEducation = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required('required')
    .max(120, 'School must be below 50 Character ')
    .min(2, 'School must be more than 2 Character'),
  degree: Yup.string()
    .trim()
    .required('required')
    .max(120, 'Degree must be below 120 Character ')
    .min(2, 'Degree must be more than 2 Character'),
  grade: Yup.string().trim().required('required'),
  started_at: Yup.string()
    .trim()
    .required('required')
    .typeError('Start Date is Required'),
  ended_at: Yup.string()
    .trim()
    .required('required')
    .typeError('Start Date is Required'),
});
export type FormInputsEducation = {
  name: string;
  degree: string;
  grade: string;
  started_at: string;
  ended_at: string;
};
export const validationSchemaLicenses = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required('required')
    .max(120, 'Collage must be below 50 Character ')
    .min(2, 'Collage must be more than 2 Character'),
  description: Yup.string()
    .trim()
    .required('required')
    .max(120, 'Description must be below 120 Character ')
    .min(2, 'Description must be more than 2 Character'),
  started_at: Yup.string()
    .trim()
    .required('required')
    .typeError('Start Date is Required'),
  ended_at: Yup.string()
    .trim()
    .required('required')
    .typeError('Start Date is Required'),
});
export type FormInputsLicenses = {
  name: string;
  description: string;
  started_at: string;
  ended_at: string;
};
export const validationSchemaLanguage = Yup.object().shape({
  language_id: Yup.string().trim().required('required'),
  language_proficiency_id: Yup.string().trim().required('required'),
});
export type FormInputsLanguage = {
  language_id?: number;
  language_proficiency_id?: number;
};
export const validationSchemaSkills = Yup.object().shape({
  skill: Yup.string()
    .required('required')
    .max(50, 'Skill must be below 50 Character ')
    .min(2, 'Skill must be more than 2 Character'),
});
export type FormInputsSkills = {
  skill: string;
};
export const validationSchemaSpecialization = Yup.object().shape({
  specialization_id: Yup.string().trim().required('required'),
});
export type FormInputsSpecialization = {
  specialization_id: string;
};
export const validationSchemaAddNewAccountant = Yup.object().shape({
  given_name: Yup.string()
    .trim()
    .required('required')
    .min(2, "Last Name doesn't accept less than 2 characters")
    .max(60, "First Name doesn't accept more than 60 characters"),
  family_name: Yup.string()
    .trim()
    .required('required')
    .min(2, "Last Name doesn't accept less than 2 characters")
    .max(60, "Last Name doesn't accept more than 60 characters"),
  phone_number: Yup.string().trim().min(10).max(20),
  title: Yup.string().required('required'),
  email: Yup.string().email(),
});
export type FormInputsAddNewAccountant = {
  given_name: string;
  family_name: string;
  email: string;
  phone_number: string;
  title: string;
};
